import React from 'react'
import tw from 'twin.macro'
import styled from 'styled-components'
import { SlBadge, SlTooltip } from '@shoelace-style/shoelace/dist/react'
import { HelpIcon } from '@nominex/dex-uikit'
import { useTranslation } from 'contexts/Localization'
import { BaseStyledBadge } from './styles'

const StyledSlBadge = styled(SlBadge)`
  ::part(base) {
    ${tw`bg-red`}
    ${BaseStyledBadge}
  }
`

const HighRiskBadge: React.FC = () => {
  const { t } = useTranslation()

  return (
    <SlTooltip
      content={t(
        'This farming pool was created without any moderation or approval from Nomiswap team. Participating in this farming pool may bring high risk of loosing all of your money. Make sure you read all details and cautions in the disclaimer and are ready to take all possible direct and indirect risks.',
      )}
      hoist
    >
      <StyledSlBadge pill>
        {t('High risk')}
        <HelpIcon height="10px" width="10px" ml="2px" />
      </StyledSlBadge>
    </SlTooltip>
  )
}

export default HighRiskBadge
